import {Component, OnInit} from '@angular/core';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {AuthRestService} from '@core/modules/rest/authentication/auth-rest.service';
import {Router} from '@angular/router';
import {WELCOME} from '@core/services/routes.service';
import {FileModel} from '@core/modules/rest/file/file.model';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {BlankDialogComponent} from '@shared/dialogs/blank-dialog/blank-dialog.component';
import {FileTypeEnum} from '@core/modules/rest/file/file-type.enum';
import {Clipboard} from '@angular/cdk/clipboard';
import {NotificationService} from '@shared/components/notification/service/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {DeleteConfirmationDialogComponent} from '../../../../display-consent/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';
import {DeleteInfoDialogComponent} from '../../../dialogs/delete-info-dialog/delete-info-dialog.component';

@UntilDestroy()
@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {
    images: any[] = [];
    imagesDetails: FileModel[] = [];
    offset = 0;
    scrollingClass: string;
    markedImages: string[] = [];
    canUploadNewMedia = true;
    noOfFilesToUpload = 0;
    cardChecked: boolean;
    oneFileSelected = false;

    constructor(private fileService: FileRestService, private authService: AuthRestService, private router: Router,
                private dialog: MatDialog, private clipboard: Clipboard, private notificationService: NotificationService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.getNewImageDetails();
    }

    getNewImageDetails(): void {
        this.fileService.getAllOrganizationImagesPagination(this.offset).subscribe(data => {
            Array.prototype.push.apply(this.imagesDetails, data);
        });
        this.offset++;
    }

    backButtonAction(): void {
        this.router.navigate([WELCOME]);
    }

    onLogOut(): void {
        this.authService.logout();
    }

    onImagesScroll(): void {
        this.getNewImageDetails();
    }

    onImagesUploaded(file: FileModel): void {
        this.imagesDetails.unshift(file);
        this.noOfFilesToUpload--;
        if (this.noOfFilesToUpload === 0) {
            this.canUploadNewMedia = true;
        }
    }

    onCheckCard($event: any): void {
        this.cardChecked = $event === true;
    }

    onImageMarked(imageId: string): void {
        const index = this.markedImages.indexOf(imageId);
        if (index === -1) {
            this.markedImages.push(imageId);
        } else {
            this.markedImages.splice(index, 1);
        }
        this.markedImages.length === 1 ? this.oneFileSelected = true : this.oneFileSelected = false;
    }

    onImageClicked(props: { path: string, type: FileTypeEnum }): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.panelClass = 'abstract-dialog-container';
        dialogConfig.data = props;
        this.dialog.open(BlankDialogComponent, dialogConfig);
    }

    setNumberOfFileToUpload(noOfFiles: number): void {
        this.noOfFilesToUpload = noOfFiles;
    }

    onCopyCode(): void {
        const fileId = this.markedImages[0];
        const file = this.imagesDetails.find(x => x.id === fileId);
        const fileType = file.type === FileTypeEnum.IMAGE ? 'IMAGE' : 'VIDEO';
        const clipboardText = '[' + fileType + ':DE:' + fileId + ']';
        this.clipboard.copy(clipboardText);
        this.notificationService.success(this.translate.instant('GENERAL.COPY_INLINE_CODE_NOTIFICATION'));
    }

    onDeleteFile(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.data = {
            title: this.translate.instant('GENERAL.ARE_YOU_SURE_DELETE_TITLE'),
            description: this.translate.instant('GENERAL.ARE_YOU_SURE_DELETE_DESCRIPTION')
        };
        const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, dialogConfig);
        dialogRef.componentInstance.closeDialogEvent.pipe(untilDestroyed(this)).subscribe(() => {
            dialogRef.close();
        });
        dialogRef.componentInstance.deleteCommentEvent.pipe(untilDestroyed(this)).subscribe(() => {
            this.fileService.deleteMediaById(this.markedImages).subscribe(nonDeleted => {
                const deletedFiles = this.markedImages.filter(image => !nonDeleted.includes(image));
                this.markedImages = nonDeleted;
                deletedFiles.forEach(id => {
                    const file = this.imagesDetails.find(image => image.id === id);
                    const fileIndex = this.imagesDetails.indexOf(file);
                    this.imagesDetails.splice(fileIndex, 1);
                });
                dialogRef.close();
                if (nonDeleted.length === 0) {
                    this.notificationService.success(this.translate.instant('GENERAL.MEDIA_DELETED'));
                    this.oneFileSelected = false;
                } else {
                    dialogConfig.disableClose = false;
                    dialogConfig.data = {
                        noOfDeleted: this.markedImages.length,
                        noOfTotal: this.markedImages.length + deletedFiles.length
                    };
                    const deleteDialogRef = this.dialog.open(DeleteInfoDialogComponent, dialogConfig);
                    deleteDialogRef.componentInstance.closeDialogEvent.pipe(untilDestroyed(this)).subscribe(() => {
                        deleteDialogRef.close();
                    });
                }
            });
        });
    }
}
